import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import InfiniteLoading from 'v3-infinite-loading';
import 'v3-infinite-loading/lib/style.css';

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401) {
        location.replace('/login');
    }

    return Promise.reject(error);
});


const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(router);
app.component('infinite-loading', InfiniteLoading);
app.mount('#app');
